import React, { useState } from "react";
import { FaSpinner } from "react-icons/fa";
import ModalShell from "./ModalShell";
import { Field, inputClass } from "./FormFields";
import { todayIso } from "./subscriptionUtils";

const ResumeModal = ({ subscription, loading, onSubmit, onClose }) => {
  const [resumeDate, setResumeDate] = useState(todayIso());

  return (
    <ModalShell
      title={`Resume ${subscription.product_name || "Subscription"}`}
      onClose={onClose}
      footer={
        <div className="flex gap-3">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 rounded-xl border border-gray-200 py-3 text-sm font-bold text-gray-600 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => onSubmit(resumeDate)}
            disabled={loading}
            className="flex-1 rounded-xl bg-primary-600 py-3 text-sm font-extrabold text-white hover:bg-primary-700 disabled:opacity-60"
          >
            {loading ? (
              <FaSpinner className="mx-auto h-4 w-4 animate-spin" />
            ) : (
              "Resume Now"
            )}
          </button>
        </div>
      }
    >
      <Field label="Resume Date">
        <input
          type="date"
          value={resumeDate}
          onChange={(event) => setResumeDate(event.target.value)}
          className={inputClass}
        />
      </Field>
    </ModalShell>
  );
};

export default ResumeModal;
